// extracted by css-extract-rspack-plugin
export default {"root":"root-gpuR_w","illustration":"illustration-ZsAwtS","text":"text-Ygwsg2","title":"title-reqBVz","subtitle":"subtitle-oV159D","button":"button-skhRAD"};